import SpayMenu from '../../assets/images/icon/menu.svg';
import SpayClosebtn from '../../assets/images/icon/close-btn.svg';
import SpayLogo from '../../assets/images/svg/spay_logo.svg';
import SpayLogo_1 from '../../assets/images/svg/spay_logo-1.svg';
import SpayArrow from '../../assets/images/icon/arrow.svg';
import SpayReadmore from '../../assets/images/icon/readmore1.svg';
import SpayReadmore2 from '../../assets/images/icon/readmore2.svg';
import SpayReadmore3 from '../../assets/images/icon/readmore3.svg';
import Spaylogo_icon from '../../assets/images/svg/logo_icon.svg';
import SpayIndividualOffer from '../../assets/images/svg/individual-offer.svg';
import SpayBusinessOffer from '../../assets/images/svg/business-offer.svg';
import SpaySimplePay from '../../assets/images/picture/simple_payment@2x.png';
import SpaySeamlessTrans from '../../assets/images/svg/seamless-transfer.svg';
import SpaySecurePayment from '../../assets/images/svg/secure-payment.svg';
import SpaySampleImg from '../../assets/images/picture/sample-img@2x.png';
import SpaySliderdotsample from '../../assets/images/svg/slider-dot.svg';
import SpayFacebook_icon from '../../assets/images/svg/facebook_icon.svg';
import SpayTwitter_icon from '../../assets/images/svg/twitter_icon.svg';
import SpayInstagram_icon from '../../assets/images/svg/instagram_icon.svg';
import SpayLinkedin_icon from '../../assets/images/svg/linkedin_icon.svg';
import Spaychecked from '../../assets/images/svg/checked.svg';
import SpayCopy_n_Paste from '../../assets/images/svg/copy-and-paste.svg';
import Spayweb_api from '../../assets/images/svg/web-api.svg';
import Spaygenerate_code from '../../assets/images/svg/generate-code.svg';
import SpayCopy_code from '../../assets/images/svg/copy-code.svg';
import Spaypaste_code from '../../assets/images/svg/paste-code.svg';
import Spayget_Transfer from '../../assets/images/svg/get-transfer.svg';
import Spayno_coding from '../../assets/images/svg/no-coding.svg';
import Spayapi_doc from '../../assets/images/svg/api-doc.svg';
import SpaySales_team from '../../assets/images/svg/sales-team.svg';
import SpaySupport_team from '../../assets/images/svg/support-team.svg';
import SpayMedia_kit from '../../assets/images/svg/media-kit.svg';
import SpayDeveloper from '../../assets/images/svg/developer.svg';
import SpaySecure_transact from '../../assets/images/svg/secure-transact.svg';
import SPayMoney_Bag from '../../assets/images/svg/money-bag.svg';
import SPay_fees from '../../assets/images/svg/spay-fees.svg';
import SPay_takeaway from '../../assets/images/svg/take-away.svg';
import DSS_cert from '../../assets/images/picture/PCI-DSS@3x.png';
import LogoIcon_white from '../../assets/images/svg/logo_icon-white.svg';
import TestUser from '../../assets/images/svg/test-user.svg';
import TransferIcon from '../../assets/images/svg/transfer.svg';
import Obk from '../../assets/images/png/obk.jpeg';
import ValueDriver from '../../assets/images/png/valuedriver.png';
import Verifyme from '../../assets/images/png/verifyme.jpeg';
import Nibss from '../../assets/images/png/nibss.jpg'
import Interswitch from '../../assets/images/png/interswitch.png'
import DirectBridge from '../../assets/images/png/direct.jpeg'


const images = () => {
    return {
        //navigation images begin
        SpayClosebtn,
        SpayMenu,
        SpayLogo,
        SpayLogo_1,
        SpayArrow,
        SpayReadmore,
        SpayReadmore2,
        SpayReadmore3,
        //navigation images end

        //Body Images begin
        Spaylogo_icon,
        SpayIndividualOffer,
        SpayBusinessOffer,
        SpaySimplePay,
        SpaySeamlessTrans,
        SpaySecurePayment,
        DSS_cert,
        //Body Images end

        //Our client container images begin
        clientImage: [Obk, ValueDriver, Verifyme, Nibss, Interswitch, DirectBridge],
        SpaySampleImg,
        SpaySliderdotsample,
        Obk,
        ValueDriver,
        //Our client container images end

        //footer images begins here
        SpayFacebook_icon,
        SpayTwitter_icon,
        SpayInstagram_icon,
        SpayLinkedin_icon,
        //footer images ends here

        //Pricing header images begins here
        Spaychecked,
        ///Pricing header images end here

        //ene-to-end images begins here
        SpayCopy_n_Paste,
        Spayweb_api,
        //ene-to-end images ends here

        //Nocoding images begins here
        Spaygenerate_code,
        SpayCopy_code,
        Spaypaste_code,
        Spayget_Transfer,
        //Nocoding images ends here

        //Payment Simplified begins here
        Spayno_coding,
        Spayapi_doc,
        //Payment Simplified ends here

        //Contact images begins here
        SpaySales_team,
        SpaySupport_team,
        SpayMedia_kit,
        SpayDeveloper,
        //Contact images ends here

        //Sales and help center images begins here
        SpaySecure_transact,
        //Sales images ends here

        //Calculator section on pricing page begins here
        SPayMoney_Bag,
        SPay_fees,
        SPay_takeaway,
        //ends here

        //dashboard images min and max
        LogoIcon_white,
        //end here

        // Sample User Image
        TestUser,
        TransferIcon
    };
};
export default images;
